export default __webpack_public_path__ + "static/media/smooth-impact.b7d65378.png";